var _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 34.3174C20.4035 34.3174 26.0001 28.7209 26.0001 21.8174C26.0001 14.9138 20.4035 9.31738 13.5 9.31738C6.59645 9.31738 1 14.9138 1 21.8174C1 23.817 1.46953 25.7069 2.30433 27.383C2.52618 27.8284 2.60002 28.3375 2.4714 28.8182L1.72689 31.6008C1.40369 32.8087 2.50877 33.9137 3.71669 33.5906L6.49925 32.8461C6.97992 32.7174 7.48903 32.7913 7.93443 33.0131C9.61048 33.8479 11.5004 34.3174 13.5 34.3174Z",
    stroke: "#787486",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20.0312H12.9152",
    stroke: "#787486",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0957 24.4961H15.2386",
    stroke: "#787486",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6441,
    cy: 11.6724,
    r: 10.855,
    fill: "#E6FFEF",
    stroke: "#787486"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.532 14.2468V13.2668L19.544 6.85478H21.056L16.086 13.2668L15.372 13.0428H23.198V14.2468H14.532ZM19.978 16.6548V14.2468L20.02 13.0428V10.9148H21.336V16.6548H19.978ZM23.8696 16.6548V15.7028L27.8596 11.8528C28.2142 11.5168 28.4756 11.2228 28.6436 10.9708C28.8209 10.7095 28.9376 10.4715 28.9936 10.2568C29.0589 10.0328 29.0916 9.81812 29.0916 9.61278C29.0916 9.10878 28.9142 8.71212 28.5596 8.42279C28.2049 8.13345 27.6869 7.98878 27.0056 7.98878C26.4829 7.98878 26.0116 8.07745 25.5916 8.25478C25.1716 8.42278 24.8076 8.68878 24.4996 9.05278L23.5476 8.22678C23.9209 7.75078 24.4202 7.38678 25.0456 7.13479C25.6802 6.87345 26.3756 6.74279 27.1316 6.74279C27.8129 6.74279 28.4056 6.85479 28.9096 7.07878C29.4136 7.29345 29.8009 7.60612 30.0716 8.01678C30.3516 8.42745 30.4916 8.91278 30.4916 9.47278C30.4916 9.79012 30.4496 10.1028 30.3656 10.4108C30.2816 10.7188 30.1229 11.0455 29.8896 11.3908C29.6562 11.7361 29.3202 12.1235 28.8816 12.5528L25.3256 15.9828L24.9896 15.4368H30.9116V16.6548H23.8696Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.57b1ad3087d055e7f8c1f1c948775fdc.svg";
export { ForwardRef as ReactComponent };